// src/pages/TradeTracker/utils/formatters.js
export const norm = (s) => String(s ?? '').trim();
export const canon = (s) => String(s ?? '').trim().toLowerCase();

export const TRADE_LABELS = {
  trade_id: 'Trade ID',
  trade_type: 'Trade Type',
  leg1_party: 'Trade Party (Leg 1)',
  leg2_party: 'Counterparty',
  trade_date: 'Trade Date',
  effective_date: 'Effective Date',
  termination_date: 'Termination Date',
};

export const EXCLUDE_TRADE_KEYS = new Set([
  'id',
  'ticker',
  'created_at',
  'user_id',
  'leg1_party_canon',
]);

export const labelForKey = (k) =>
  TRADE_LABELS[k] || k.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

export const formatVal = (v) => (v == null || v === '' ? '—' : String(v));

export const unitForMax = (maxAbs) => {
  if (maxAbs >= 1e9) return { div: 1e9, suffix: 'B' };
  if (maxAbs >= 1e6) return { div: 1e6, suffix: 'M' };
  if (maxAbs >= 1e3) return { div: 1e3, suffix: 'K' };
  return { div: 1, suffix: '' };
};

export const fullUSD = (num) => {
  if (num == null || isNaN(num)) return '–';
  const n = Number(num);
  const sign = n < 0 ? '-' : '';
  const abs = Math.abs(n).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${sign}$${abs}`;
};

export const isCommodityTrade = (tradeType) =>
  String(tradeType ?? '').trim().toLowerCase().startsWith('commodity');

export const wholeUnits = (num) => {
  if (num == null || isNaN(num)) return '–';
  return Number(num).toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
};

export const formatNotional = (num, tradeType) =>
  isCommodityTrade(tradeType) ? wholeUnits(num) : fullUSD(num);
